import { connect, useSelector } from 'react-redux';

import { getEvent } from 'common/entities/event/selectors';
import { getEventId } from 'common/store/events/selectors';
import { APP } from '../index';

// Constants
export const EVENT = 'event';

export const SET_EVENT = `${APP}/SET_EVENT`;

// Reducers
export const INIT_STATE = {
    eventId: '',
};

export const reducers = {
    [SET_EVENT](state, { payload }) {
        return {
            ...state,
            eventId: payload,
        };
    },
};

// Actions
export const setEvent = (id) => ({
    type: SET_EVENT,
    payload: id,
});

// App module
export default {
    initialState: INIT_STATE,
    reducers,
};

export const useEvent = () => {
    const eventId = useSelector(getEventId);
    // A little bit of partial application to get the selector arguments
    // passed correctly for useSelector
    return useSelector((state) => getEvent(state, eventId));
};

export const useEventId = () => useSelector(getEventId);

const mapStateToProps = (state) => {
    const eventId = getEventId(state);

    return {
        event: getEvent(state, eventId),
    };
};

export const withEvent = (Component) => connect(mapStateToProps)(Component);

const mapStateToPropsId = (state) => ({
    eventId: getEventId(state),
});

export const withEventId = (Component) => connect(mapStateToPropsId)(Component);
